/**
 * Create utility for SVG elements
 */

module.exports = create;


var attr = require('./attr');
var parse = require('./util/parse');
var ns = require('./util/ns');


/**
 * Create a specific type from name or SVG markup.
 *
 * @param {String} name the name or markup of the element
 * @param {Object} [attrs] attributes to set on the element
 *
 * @returns {SVGElement}
 */
function create(name, attrs) {
  var element;

  if (name.charAt(0) === '<') {
    element = parse(name).firstChild;
    element = document.importNode(element, true);
  } else {
    element = document.createElementNS(ns.svg, name);
  }

  if (attrs) {
    attr(element, attrs);
  }

  return element;
}


// WEBPACK FOOTER //
// ./~/tiny-svg/lib/create.js